import React from "react";
import Countdown from "react-countdown";
import { Link } from "react-router-dom";
import i18n from "../../../i18n";
import { formatCurrency } from "../../../state/utils";
import { CustomEnroll } from "../../helpers/customEnroll";
import { SaudiRiyalLogo } from "../../logo/saudiLogo";

let is_logged = localStorage.getItem("is_logged_in") ? true : false;

const FinishBid = () => (
  <div className="bid-ended">
    <i className="fa fa-clock-o me-2"></i>
    {i18n.t("auction_end")}
  </div>
);

const rendererEnds = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return <FinishBid />;
  } else {
    return (
      <div className="countdown-container ends-timer">
        <div className="countdown-header">
          <i className="fa fa-hourglass-half me-2"></i>
          {i18n.t("ends_after")}
        </div>
        <div className="countdown-grid">
          <div className="countdown-item">
            <span className="countdown-number">{days}</span>
            <span className="countdown-label">{i18n.t("lbl_day")}</span>
          </div>
          <div className="countdown-item">
            <span className="countdown-number">{hours}</span>
            <span className="countdown-label">{i18n.t("lbl_hour")}</span>
          </div>
          <div className="countdown-item">
            <span className="countdown-number">{minutes}</span>
            <span className="countdown-label">{i18n.t("lbl_minute")}</span>
          </div>
          <div className="countdown-item">
            <span className="countdown-number">{seconds}</span>
            <span className="countdown-label">{i18n.t("lbl_second")}</span>
          </div>
        </div>
      </div>
    );
  }
};

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return "";
  } else {
    return (
      <div className="countdown-container starts-timer">
        <div className="countdown-header">
          <i className="fa fa-play-circle me-2"></i>
          {i18n.t("starts_after")}
        </div>
        <div className="countdown-grid">
          <div className="countdown-item">
            <span className="countdown-number">{days}</span>
            <span className="countdown-label">{i18n.t("lbl_day")}</span>
          </div>
          <div className="countdown-item">
            <span className="countdown-number">{hours}</span>
            <span className="countdown-label">{i18n.t("lbl_hour")}</span>
          </div>
          <div className="countdown-item">
            <span className="countdown-number">{minutes}</span>
            <span className="countdown-label">{i18n.t("lbl_minute")}</span>
          </div>
          <div className="countdown-item">
            <span className="countdown-number">{seconds}</span>
            <span className="countdown-label">{i18n.t("lbl_second")}</span>
          </div>
        </div>
      </div>
    );
  }
};

export class GroupCard extends React.Component {
  constructor() {
    super();
    this.state = {
      wishlist: false,
      like: false,
      bidTimeStopped: false,
      now: () => {
        let time = new Date().toLocaleTimeString("en-US", {
          timeZone: "Asia/Riyadh",
        });
        let dt = new Date().toISOString("en-US").split("T")[0];
        let newDt = dt + " " + time;
        newDt = new Date(newDt.replace(/-/g, "/"));
        return newDt;
      },
    };
    this.incrementTime = this.incrementTime.bind(this);
    this.addWishList = this.addWishList.bind(this);
    this.addLike = this.addLike.bind(this);
  }

  componentDidMount() {
    if (this.props.group) {
      setInterval(this.incrementTime, 1000);
    }
  }

  incrementTime() {
    let { group } = this.props;
    if (!group) {
      console.error("group is undefined in props");
      return;
    }
    let dt = new Date(group.server_time);
    dt.setSeconds(dt.getSeconds() + 1);
    group.server_time = dt;
    this.setState({ group });
  }

  createDate(dt) {
    return dt ? new Date(dt.replace(/-/g, "/")) : null;
  }

  getStatusBadgeClass(status) {
    const statusClasses = {
      E: "status-expired",
      F: "status-featured",
      A: "status-active",
      U: "status-upcoming",
    };
    return `status-badge ${statusClasses[status] || "status-active"}`;
  }

  async addWishList(wishlist) {
    // Implement wishlist functionality if needed
    this.setState({ wishlist });
  }

  async addLike(like) {
    // Implement like functionality if needed
    this.setState({ like });
  }

  render() {
    let current_lng = localStorage.getItem("I18N_LANGUAGE");
    let group = this.props.group;
    let img_src = group.group_image;
    let startDateAr = group.start_date_ar;
    let endDateAr = group.end_date_ar;

    let statusAr = group.status_label;
    let disp_status = "";
    let statusClass = this.getStatusBadgeClass(statusAr?.status);

    if (statusAr && statusAr["status"]) {
      disp_status = current_lng === "ar" ? statusAr["ar"] : statusAr["en"];
    }

    let now = this.state.now;
    let endTime = new Date(this.createDate(group.start_date)).getTime();
    let aucEndTime = new Date(this.createDate(group.end_date)).getTime();

    let end_time = endDateAr && endDateAr["time"] ? endDateAr["time"] : "";
    end_time = end_time.replace("PM", i18n.t("PM"));
    end_time = end_time.replace("AM", i18n.t("AM"));

    let start_time = startDateAr && startDateAr["time"] ? startDateAr["time"] : "";
    start_time = start_time.replace("PM", i18n.t("PM"));
    start_time = start_time.replace("AM", i18n.t("AM"));

    let amount_label = "";
    if (this.props.type === "upcoming") {
      amount_label = i18n.t("start_bid_amount");
    } else if (this.props.type === "previous") {
      amount_label = i18n.t("last_bid_amount");
    } else {
      amount_label = i18n.t("current_amount");
    }

    let orgImage = "";
    if (
      group &&
      group.organizationDetails &&
      group.organizationDetails.file_organization_image_full
    ) {
      orgImage = group.organizationDetails.file_organization_image_full;
    }

    let auction_started = false;
    let groupStartDate = new Date(this.createDate(group.start_date));
    if (groupStartDate < now()) {
      auction_started = true;
    }

    return (
      <React.Fragment key={this.props.key}>


        <div className="col-md-4 col-sm-6 col-xs-12 pt-3 auc-card-container m-auto">
          <div className="modern-auction-card">
            {/* Card Header with Image */}
            <div className="card-header-modern">
              <img src={img_src} className="auction-image-modern" alt="" />

              {/* Status Badge */}
              <span className={statusClass}>{disp_status}</span>

              {/* Organization Badge */}
              {orgImage && (
                <img src={orgImage} alt="Organization" className="org-badge-modern" />
              )}

              {/* Days Remaining */}
              {/* <div className="days-remaining-modern">
                <i className="fa fa-calendar"></i>
                <span>{group.days_remaining}</span>
              </div> */}

              {/* Social Share */}
              
            </div>

            {/* Card Body */}
            <div className="card-body-modern">
              {/* Title */}
               <Link
                  to={"/grouped-auctions/" + group.group}
                  className="auction-title-modern"
                >
                {current_lng === "ar" && group.group_name_ar ? group.group_name_ar : group.group_name}
              </Link>

              {/* Interaction Bar */}
              <div className="interaction-bar-modern">
                <button className="interaction-btn-modern">
                  <i className="fa fa-eye"></i>
                  {this.props.total_views}
                </button>
                <button className={`interaction-btn-modern ${this.state.wishlist ? 'active' : ''}`}
                  onClick={(event) => { this.addWishList(!this.state.wishlist); }}
                >
                  <i className={this.state.wishlist ? "fa fa-heart" : "fa fa-heart-o"}></i>
                </button>
                <button className={`interaction-btn-modern ${this.state.like ? 'active' : ''}`}
                  onClick={(event) => { this.addLike(!this.state.like); }}
                >
                  <i className={this.state.like ? "fa fa-thumbs-up" : "fa fa-thumbs-o-up"}></i>
                </button>

                <button className="interaction-btn-modern">
                  {i18n.t("total_auctions")} {group.auctions_count}
                </button>

                <button className="interaction-btn-modern">
                  <i className="fa fa-calendar"></i>
                  &nbsp;{group.days_remaining}
                </button>

              </div>

              {/* Bid Time Status */}
              {(group.is_bid_time_ends || group.status_dis !== "A") && (
                <div className="bid-ended">
                  <i className="fa fa-times-circle me-2"></i>
                  {i18n.t("bid_time_ends")}
                </div>
              )}

              {/* Countdown Timers */}
              {group.status_dis === "A" && !group.is_bid_time_ends && group.end_date && (
                <Countdown
                  date={endTime}
                  renderer={renderer}
                  onComplete={() => { this.setState({ bidTimeStopped: true }); }}
                  now={() => new Date(group.server_time)}
                />
              )}

              {group.status_dis === "A" && !group.is_bid_time_ends && group.end_date && auction_started && (
                <Countdown
                  date={aucEndTime}
                  renderer={rendererEnds}
                  onComplete={() => { this.setState({ bidTimeStopped: true }); }}
                  now={() => new Date(group.server_time)}
                />
              )}

              {/* Amount Grid */}
              <div className="amount-grid-modern">
                <div className="amount-card-modern">
                  <div className="amount-label-modern">{i18n.t("start_bid_amount")}</div>
                  <div className="amount-value-modern">
                    {formatCurrency(group.start_amount)} <SaudiRiyalLogo/>
                  </div>
                </div>

                <div className="amount-card-modern">
                  <div className="amount-label-modern">{amount_label}</div>
                  <div className="amount-value-modern">
                    {formatCurrency(group?.current_amount)} <SaudiRiyalLogo />
                  </div>
                </div>

                <div className="amount-card-modern">
                  <div className="amount-label-modern">{i18n.t("gurantee_amount")}</div>
                  <div className="amount-value-modern">{formatCurrency(group?.group_info?.amount)}  <SaudiRiyalLogo /></div>
                </div>

                <div className="amount-card-modern">
                  <div className="amount-label-modern">{i18n.t("vat")}</div>
                  <div className="amount-value-modern">{group.vat || "0"}%</div>
                </div>

              </div>


              {/* Date Section */}
              <div className="amount-grid-modern">
                <div className="date-section-modern">
                  <div className="date-item-modern">
                    <div className="amount-label-modern">{i18n.t("start_date")}</div>
                    <div className="date-value">
                      {startDateAr && startDateAr["date"] ? startDateAr["date"] : ""}
                    </div>
                    <div className="date-text">({start_time})</div>
                    <div className="date-text">
                      {startDateAr && startDateAr["day"] ? i18n.t(startDateAr["day"]) : ""}
                    </div>
                  </div>
                </div>
                <div className="date-section-modern">
                  <div className="date-item-modern">
                    <div className="amount-label-modern">{i18n.t("end_date")}</div>
                    <div className="date-value">
                      {endDateAr && endDateAr["date"] ? endDateAr["date"] : ""}
                    </div>
                    <div className="date-text">({end_time})</div>
                    <div className="date-text">
                      {group.days_remaining !== 0 && (
                        <>
                          {group.days_remaining} {i18n.t("days_of_auction")}
                        </>
                      )}
                    </div>

                  </div>
                </div>
              </div>

              {/* Auction Count Section */}
              {/* <div className="amount-card-modern mb-3">
                <div className="amount-label-modern">{i18n.t("total_auctions")}</div>
                <div className="amount-value-modern">{group.auctions_count}</div>
              </div> */}

              {/* Final Approval Button */}
              <button className="btn final-approval-btn">
                {i18n.t("final_approval_lbl")}
              </button>

              {/* Action Buttons */}
              <div className="action-buttons-modern">
                <Link
                  to={"/grouped-auctions/" + group.group}
                  className="btn btn-primary-custom flex-fill"
                >
                  <i className="fa fa-info-circle me-2"></i>
                  {i18n.t("list_auctions")}
                </Link>

                {this.props.can_bid && group.status_dis === "A" && !group.is_enrolled && group.first_auction_id && group.is_grouped === 1 && group.is_grouped_enroll === 1 && (
                  <Link
                    to={!is_logged ? "/login" : "/enroll/" + group.first_auction_id}
                    className="btn btn-primary-custom flex-fill"
                  >
                    <i className="fa fa-user-plus me-2"></i>
                    {i18n.t("enroll")}
                  </Link>
                )}

                {this.props.can_bid && group.status_dis === "A" && group.first_auction_id && group.is_grouped === 1 && group.is_grouped_enroll === 0 && (
                  <CustomEnroll
                    group={group.group}
                    className="btn btn-warning-custom flex-fill"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}